<template>
  <!-- "Weitere Projekte summieren" als abgesetzte Filterfläche (jr-panel). -->
  <div class="jr-panel cmp-panel">
    <div class="jr-panel__texts">
      <span class="jr-panel__title">Weitere Projekte summieren</span>
      <span class="jr-panel__hint">Zusätzlich zum Hauptprojekt. Werte werden addiert.</span>
    </div>
    <span class="jr-panel__divider" aria-hidden="true" />
    <div class="cmp-panel-body">
      <span class="flabel">Marke</span>
      <div v-for="brand in groupedBrandProjects" :key="brand.kat" class="bdd">
        <div class="bddbtn" :class="{ has: selectedCount(brand) > 0 }">
          <span
            class="bddmain"
            :title="allSelected(brand) ? 'Alle abwählen' : 'Alle auswählen'"
            @click="toggleAllBrand(brand)"
          >
            <span>{{ brand.label }}</span>
            <span class="bddcount">{{ selectedCount(brand) }}/{{ brand.projects.length }}</span>
          </span>
          <span class="bddcar" title="Einzeln wählen" @click="toggleDropdown(brand.kat)">▾</span>
        </div>

        <template v-if="openKat === brand.kat">
          <div class="bdd-back" @click="closeDropdown" />
          <div class="bddmenu">
            <div class="bddhead">
              <span>{{ brand.label }}</span>
              <span class="bddall" @click="toggleAllBrand(brand)">{{ allSelected(brand) ? 'Keine' : 'Alle' }}</span>
            </div>
            <template v-if="groupItems(brand).length">
              <div v-for="group in groupItems(brand)" :key="group.label" class="bddgrp">
                <div class="bddgrplab">{{ group.label }}</div>
                <label
                  v-for="project in group.items"
                  :key="project.id"
                  class="bdditem"
                  :class="{ 'bdditem--main': project.isMainProject }"
                >
                  <input
                    type="checkbox"
                    :checked="project.isMainProject || selectedCompareIds.includes(project.id)"
                    :disabled="project.isMainProject"
                    @change="!project.isMainProject && $emit('toggle', project.id)"
                  >
                  <span>{{ project.shortLabel }}<template v-if="project.isMainProject"> <em class="bdditem__main-tag">(Hauptprojekt)</em></template></span>
                </label>
              </div>
            </template>
            <div v-else class="bddempty">Keine Einträge</div>
          </div>
        </template>
      </div>
      <button
        v-if="selectedCompareIds.length"
        type="button"
        class="jr-link-button"
        @click="$emit('clear')"
      >
        Zurücksetzen
      </button>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    groupedBrandProjects: {
      type: Array,
      default: () => []
    },
    selectedCompareIds: {
      type: Array,
      default: () => []
    }
  },
  emits: ['toggle', 'set-brand', 'clear'],
  data() {
    return {
      openKat: null
    };
  },
  methods: {
    hasMainProject(brand) {
      return brand.projects.some((p) => p.isMainProject);
    },
    selectedCount(brand) {
      const mainCount = this.hasMainProject(brand) ? 1 : 0;
      const compareCount = brand.projects.filter(
        (p) => !p.isMainProject && this.selectedCompareIds.includes(p.id)
      ).length;
      return mainCount + compareCount;
    },
    allSelected(brand) {
      return brand.projects.length > 0 && this.selectedCount(brand) === brand.projects.length;
    },
    toggleDropdown(kat) {
      this.openKat = this.openKat === kat ? null : kat;
    },
    closeDropdown() {
      this.openKat = null;
    },
    toggleAllBrand(brand) {
      this.$emit('set-brand', {
        kat: brand.kat,
        on: !this.allSelected(brand)
      });
    },
    groupItems(brand) {
      const merch = brand.projects.filter((project) => project.ober === 'print');
      const digital = brand.projects.filter((project) => project.ober === 'digital');
      const groups = [];

      if (merch.length) {
        groups.push({ label: 'Merch', items: merch });
      }
      if (digital.length) {
        groups.push({ label: 'Digital', items: digital });
      }

      return groups;
    }
  }
};
</script>

<style scoped>
.cmp-panel {
  margin-top: 12px;
}

.cmp-panel-body {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  flex: 1;
  min-width: 0;
}
</style>
